// extracted by mini-css-extract-plugin
export default {"list":"VirtualList_list__oVLJ+","listHidden":"VirtualList_listHidden__32X4Y"};